<template lang="pug">
  .whatsapp-forms
    .background-header.white
      v-container.white.pb-1(style="max-width:600px")
        div.my-2.mx-2
          v-text-field(v-model="searchText" :placeholder="$t('search_form')" hide-details dense outlined height="40" background-color="basic200")
            template(v-slot:append)
              eva-icon(name="search-outline" :fill="$vuetify.theme.themes[$theme].basic600")
        div.my-2.mx-2(v-if="member.role === 'Admin'")
          v-btn.s1.text-capitalize.px-0(color="textColorAccent" text @click="clickAddForm")
            eva-icon.mr-3(name="plus-circle-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" width="20" height="20" style="margin-top: 3px")
            | {{$t('create_form')}}

    v-container.pa-0.mb-4(style="max-width:600px")
      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)
      .contain-layout.mx-2(v-else)
        v-layout.my-6(v-if="forms.length == 0")
          v-row.fill-height.ma-0(align='center' justify='center')
            div.mx-auto
              v-img.mx-auto(:src="require('@/assets/images/icon_empty.png')" style="width:80px; height:80px" contain)
              p.caption {{$t('start_form_creation')}}
        template(v-else)
          v-divider.basic300
          template(v-for="(form, index) in forms")
            form-item(:key="form.id" :parentForm.sync="form" :statusd="statusDisable" :company="company" :reachFormCountLimit="reachFormCountLimit" @deleted="handleDeleteItem" @statusChange="fetchPublishedFormCount" @updatePublish="$event === 'published' ? publishedFormCount++ : publishedFormCount--" @edited="handleEditItem" @duplicated="handleDuplicateItem")
            v-divider.basic300

      y-pagination.ma-4(v-model="page" :pageSize="fetchCount" :count="count")

    .modals
      add-wa-form(v-if="showAddWaFormDialog" :open.sync="showAddWaFormDialog" :company="company" @added="handleAddItem")

</template>

<script>
import { mapState, mapActions } from 'vuex'
import queryString from 'query-string'
import AddWaForm from '@/components/dialogs/AddWaForm.vue'
import FormItem from '@/components/FormItem.vue'
export default {
  name: 'Forms',
  components: { AddWaForm, FormItem },
  props: ['company'],
  data: () => ({
    isFetching: false,
    showAddWaFormDialog: false,
    isTyping: false,
    selectedStyle: 0,
    fetchCount: 10,
    page: 1,
    // totalPage: 1,
    searchText: '',
    forms: [],
    totalCount: 0,
    count: 0,
    searchCountDown: null,
    publishedFormCount: 0,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapState('subscriptions', ['yezzaSubscription']),
    reachFormCountLimit () {
      const maxCount = this.yezzaSubscription.limitations.form
      if (maxCount === -1) {
        return false
      }
      return Boolean(this.publishedFormCount >= maxCount || this.totalCount >= maxCount)
    },
    statusDisable () {
      const maxCount = this.yezzaSubscription.limitations.form
      if (maxCount === -1) {
        return false
      }
      return Boolean(this.publishedFormCount >= maxCount)
    }
  },
  watch: {
    page (val) {
      var q = queryString.parse(location.search)
      q.page = val
      let newUrl = queryString.stringify(q)
      history.pushState({}, null, location.pathname + '?' + newUrl)
      if (!this.isFetching) {
        if (this.searchText) {
          this.searchItem(val)
        } else {
          this.fetchForms(val)
        }
      }
    },
    searchText () {
      if (this.searchCountDown) {
        clearTimeout(this.searchCountDown)
      }
      this.searchCountDown = setTimeout(() => {
        this.searchItem(1)
      }, 500)
    }
  },
  mounted () {
    this.fetchPublishedFormCount()
    if (!this.$route.query.page) {
      this.fetchForms(1)
    } else {
      this.fetchForms(this.$route.query.page)
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForms(page) {
      this.page = parseInt(page)
      this.isFetching = true
      let url = `/forms/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id&type=whatsapp&type=pay_now&type=both&type=donation&layout_exclude=landing`
      if (this.member.role === 'Agent') {
        url += `&agent_member_id=${this.member.id}&members=${this.member.id}`
      }
      this.$axios.get(url).then((response) => {
        this.isFetching = false
        this.forms = response.data.results
        this.totalCount = response.data.count
        this.count = response.data.count
      })
      .catch((error) => {
        if (error.response.data.detail === 'Invalid page.') {
          this.fetchForms(1)
        }
      })
    },
    fetchPublishedFormCount () {
      this.$axios.get(`/companies/${this.company.id}`)
        .then(resp => {
          this.publishedFormCount = resp.data.published_form_count
        })
        .catch(() => {})
    },
    clickAddForm () {
       if (this.reachFormCountLimit  ) {
        this.showMessage(['upgrade'])
        return
      }
      this.showAddWaFormDialog = true
    },
    searchItem (page) {
      this.page = parseInt(page)
      let searchUrl = searchUrl = `/forms/?page=${page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-id&type_exclude=store`
      if (this.searchText) {
        searchUrl += `&search=${this.searchText}`
      }
      if (this.member.role === 'Agent') {
        searchUrl += `&agent_member_id=${this.member.id}&members=${this.member.id}`
      }
      this.isFetching = true
      this.$axios.get(searchUrl)
        .then((response) => {
          this.isFetching = false
          this.forms = response.data.results
          this.count = response.data.count
        })
        .catch(() => {})
    },
    handleDeleteItem (item) {
      this.forms = this.forms.filter((x) => x !== item)
      this.totalCount --
    },
    handleAddItem (item) {
      this.forms.splice(0, 0, item)
      this.totalCount ++
    },
    handleDuplicateItem (item) {
      this.forms.splice(0, 0, item)
      this.totalCount ++
    },
    handleEditItem (item) {
      let editIndex = 0
      this.forms.forEach((form, index) => {
        if (form.id === item.id) {
          editIndex = index
        }
      })
      this.forms = this.forms.filter((x) => x.id !== item.id)
      this.forms.splice(editIndex, 0, item)
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>